import React, { useState, useEffect } from 'react'
import { HeaderContainer, HeaderTitle, BounceAnimatedContainer, HealtheraButton } from '../../healtheraComponents'
import { useDispatch } from "react-redux"
import * as actions from '../../redux/geozones'
import { withRouter } from 'react-router'
import DynamicForm from '../DynamicForm/DynamicForm'
import { Schema } from './InputSchema'
import { Flex, Box } from 'reflexbox'
import set from 'set-value'
import { validated } from '../../helpers'

const GeozonesList = (props) => {
  const dispatch = useDispatch()
  const [schema, setSchema] = useState({})
  const [geozone] = useState({ name: '', code: '', note: '' })
  const [validationArray] = useState({ code: false, name: false, note: false })
  const [disabled, setDisabled] = useState(true)
  const createGeozone = () => {
    dispatch(actions.addGeozone(geozone))
    props.history.push(`${process.env.PUBLIC_URL}/regions`)
  }

  const handleChange = ({ field, value, validation }) => {
    set(validationArray, field, validation)
    set(geozone, field, value)
    setDisabled(!validated(validationArray))
  }

  useEffect(() => {
    setSchema(Schema({ name: '', code: '' }))
  }, [])

  return (
    <BounceAnimatedContainer>
      <HeaderContainer padding={`20px 0`}>
        <HeaderTitle fontSize={`24px`}>Add New Region</HeaderTitle>
      </HeaderContainer>
      <Flex>
        <Box w={`50%`}>
          <DynamicForm onChange={handleChange} fields={schema.zone} />
          <HealtheraButton disabled={disabled} color="primary" margin={`20px 0`} onClick={createGeozone}>Save Geozone</HealtheraButton>
        </Box>
      </Flex>
    </BounceAnimatedContainer>
  )
}
export default withRouter(GeozonesList)
